<template>

  <section class="px-14 sm-max:px-5 space-y-8 bg-grayD pt-12 md-max:pt-10 pb-10 md-max:pb-6 mt-3">

    <h2 class="lg:text-38 md:text-28 text-xl text-center md-max:leading-5 sm-max:text-xl md-only:text-28 leading-head md-max:px-4"><strong v-html="title1Row"></strong>

    </h2>

    <div>

      <div class="lg:pt-7">
        <div
            v-for="item in items"
            :key="item.id"
            class="grid md:grid-cols-12 mt-6 gap-6 md-max:mb-16 sm-max:gap-3 items-start mb-12 md-max:mb-4"
        >
          <div class="col-span-5 md-max:col-span-12">
            <nuxt-img
                class="m-auto lg:w-full"
                width="390"
                height="287"
                loading="lazy"
                format="webp"
                :alt="item.alt"
                :src="item.imageSrc"
            ></nuxt-img>
          </div>

          <div class="col-span-7 md-max:col-span-12 md-max:text-center lg:pl-7 lg:pt-5">
            <h3 class="text-32 uppercase sm-max:text-lg md-max:leading-5" v-html="item.title"></h3>

            <div class="lg:text-21 md:text-lg text-base md:leading-30 md-max:text-center sm-max:mt-2 mt-4"
               v-html="item.description"></div>
          </div>
        </div>
      </div>

    </div>

<!--    <div id="testimonial">-->

<!--    </div>-->

  </section>

</template>

<script setup>

const props = defineProps({
  title1Row: {
    type: String,
    default: "And that’s not all. This coffee includes <br class=\"sm-max:hidden\">all\n" +
        "      the above qualities and\n" +
        "      more:"
  },
  items: {
    type: Array,
    default: () => [
      {
        id: 1,
        alt: 'HIGH ELEVATION GROWN',
        imageSrc: '/assets/images/freebag-include-img1.png',
        title: 'High Elevation Grown',
        description:
            'High-altitude specialty coffees, generally command a far better market price due to their exceptional flavor and vibrancy, lower yield per coffee tree, and challenge to coffee farmers in remote mountainous areas. This means truly superb coffee beans that represent one of the world\'s most affordable luxuries.',
      },
      {
        id: 2,
        alt: 'SUN-DRIED',
        imageSrc: '/assets/images/freebag-include-img2.png',
        title: 'SUN-DRIED',
        description:
            'Once washed, the beans are sun-dried until they\'ve achieved a moisture content of 11.5%. (Too much moisture and you risk mold; too dry and the flavor of the coffee is spoiled.) Finally, the beans transition to a 30-day "rest" period which allows the flavor profile of your beans to deepen in richness, complexity and taste.',
      },
      {
        id: 3,
        alt: 'FAIRLY TRADED',
        imageSrc: '/assets/images/freebag-include-img10.jpg',
        title: 'FAIRLY TRADED',
        description:
            'This coffee is grown in a sustainable environment. Farmers grow their coffee which is an <br class="lg:block hidden"/> environmentally friendly way of producing crops. Not only is this good for the environment, but it is better for the coffee. By employing farming methods, the fairly traded coffee is grown by farmers who are paid a fair wage for doing so.',
      },
      {
        id: 4,
        alt: 'SPECIALTY BEAN',
        imageSrc: '/assets/images/freebag-include-img4.jpg',
        title: 'SPECIALTY BEAN',
        description:
            'Specialty coffee represents the very best of the world\'s coffee yield or the TOP 3% of global production. These beans are the largest beans that are hand picked out because they are perfect with no defects. Only the very best.',
      },
      {
        id: 5,
        alt: 'SPECIALTY BEAN',
        imageSrc: '/assets/images/freebag-include-img5.jpg',
        title: 'TESTED FOR PESTICIDES',
        description: `Some other coffee farms slash and burn the rainforest and spray their coffee beans with toxic pesticides to keep the bugs away. We think it's better to grow our coffee in nutrient-rich virgin soil.
        <br><br>
        If you're anything like me, I prefer to grow our coffee the natural way, in the cool shade of ancient trees, where the beans can ripen slowly and migratory birds, like the beautiful Scarlet Tanager, can naturally manage bugs like the coffee farmer's archenemy - the coffee borer.`,
      },
      {
        id: 6,
        alt: 'LOW ACID',
        imageSrc: '/assets/images/freebag-include-img6.jpg',
        title: 'LOW ACID',
        description: `Conventional coffee farms soak the ground with harsh chemical fertilizers - as much as 250 pounds per acre! When you grind up beans that have chemical residue and add hot water to them, you concentrate those chemicals into your cup of coffee.`,
      },
      {
        id: 7,
        alt: 'NON-GMO',
        imageSrc: '/assets/images/freebag-include-img7.jpg',
        title: 'NON-GMO',
        description: `Our beans are grown from single origin plants that have not been genetically modified. We believe in keeping our coffee as clean and pure as possible not just for health reasons, but to protect the environment and the delicate flavor profile that you get with every perfect cup.`,
      },
    ]
  }
})

defineBuilderComponent({
    friendlyName: "QualitiesMore",
    canHaveChildren: true,
    inputs: [
        {
            name: "title1Row",
            type: "richText",
            defaultValue: "And that’s not all. This coffee includes <br class=\"sm-max:hidden\">all\n      the above qualities and\n      more:"
        },
        {
            name: "items",
            type: "list",
            subFields: [
                {
                    name: "alt",
                    type: "text"
                },
                {
                    name: "imageSrc",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "png",
                        "svg"
                    ]
                },
                {
                    name: "title",
                    type: "richText"
                },
                {
                    name: "description",
                    type: "richText"
                }
            ],
            defaultValue: [
                {
                    id: 1,
                    alt: "HIGH ELEVATION GROWN",
                    imageSrc: "/assets/images/freebag-include-img1.png",
                    title: "High Elevation Grown",
                    description: "High-altitude specialty coffees, generally command a far better market price due to their exceptional flavor and vibrancy, lower yield per coffee tree, and challenge to coffee farmers in remote mountainous areas. This means truly superb coffee beans that represent one of the world's most affordable luxuries."
                },
                {
                    id: 2,
                    alt: "SUN-DRIED",
                    imageSrc: "/assets/images/freebag-include-img2.png",
                    title: "SUN-DRIED",
                    description: "Once washed, the beans are sun-dried until they've achieved a moisture content of 11.5%. (Too much moisture and you risk mold; too dry and the flavor of the coffee is spoiled.) Finally, the beans transition to a 30-day \"rest\" period which allows the flavor profile of your beans to deepen in richness, complexity and taste."
                },
                {
                    id: 3,
                    alt: "FAIRLY TRADED",
                    imageSrc: "/assets/images/freebag-include-img10.jpg",
                    title: "FAIRLY TRADED",
                    description: "This coffee is grown in a sustainable environment. Farmers grow their coffee which is an environmentally friendly way of producing crops. Not only is this good for the environment, but it is better for the coffee. By employing farming methods, the fairly traded coffee is grown by farmers who are paid a fair wage for doing so."
                },
                {
                    id: 4,
                    alt: "SPECIALTY BEAN",
                    imageSrc: "/assets/images/freebag-include-img4.jpg",
                    title: "SPECIALTY BEAN",
                    description: "Specialty coffee represents the very best of the world's coffee yield or the TOP 3% of global production. These beans are the largest beans that are hand picked out because they are perfect with no defects. Only the very best."
                },
                {
                    id: 5,
                    alt: "SPECIALTY BEAN",
                    imageSrc: "/assets/images/freebag-include-img5.jpg",
                    title: "TESTED FOR PESTICIDES",
                    description: "Some other coffee farms slash and burn the rainforest and spray their coffee beans with toxic pesticides to keep the bugs away. We think it's better to grow our coffee in nutrient-rich virgin soil.\n  <br><br>\n  If you're anything like me, I prefer to grow our coffee the natural way, in the cool shade of ancient trees, where the beans can ripen slowly and migratory birds, like the beautiful Scarlet Tanager, can naturally manage bugs like the coffee farmer's archenemy - the coffee borer."
                },
                {
                    id: 6,
                    alt: "LOW ACID",
                    imageSrc: "/assets/images/freebag-include-img6.jpg",
                    title: "LOW ACID",
                    description: "Conventional coffee farms soak the ground with harsh chemical fertilizers - as much as 250 pounds per acre! When you grind up beans that have chemical residue and add hot water to them, you concentrate those chemicals into your cup of coffee."
                },
                {
                    id: 7,
                    alt: "NON-GMO",
                    imageSrc: "/assets/images/freebag-include-img7.jpg",
                    title: "NON-GMO",
                    description: "Our beans are grown from single origin plants that have not been genetically modified. We believe in keeping our coffee as clean and pure as possible not just for health reasons, but to protect the environment and the delicate flavor profile that you get with every perfect cup."
                }
            ]
        }
    ]
});
</script>